import { render, staticRenderFns } from "./AddCouponDialog.vue?vue&type=template&id=b37fe3fe&"
import script from "./AddCouponDialog.vue?vue&type=script&lang=js&"
export * from "./AddCouponDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports